import Backbone from '@polleverywhere/backbone'
import URI from 'urijs'

export default class DiscourseVote extends Backbone.Model {
  initialize (attrs = {}, options = {}) {
    /**
     * Hold reference to parent result this vote belongs to. Every result has at
     * most a single vote model associated with it based on `result_id`.
     * @type {DiscourseResult}
     */
    this.result = options.result
  }

  url () {
    if (!this.result) {
      throw new Error('Vote must be associated to a result')
    }
    return URI(this.result.url()).segment('vote').toString()
  }

  parse (attrs = {}, options = {}) {
    if (attrs.result) {
      // When result object is contained in response, use it to resync the
      // associated result model to the most recent state.
      this.result.set(attrs.result)
      delete attrs.result
    }

    return super.parse(attrs, options)
  }

  save (attrs, options) {
    // Vote is a singleton resource binded to a result, meaning there can only
    // be at most one vote model associated with any one result. Thus, we never
    // need to `create` the vote and instead always send updates via PUT.
    // Backend lazily creates a new vote if one doesn't already exist.
    return super.save(attrs, Object.assign({}, options, {
      method: 'PUT'
    }))
  }
}
